import request from '@/util/request'

export function saveOrUpdate(data) {
  return request({
    url: 'annex/saveOrUpdate',
    method: 'post',
    data
  })
}

export function page(query) {
  return request({
    url: `annex/page/${query.orderColumn}/${query.isAsc}/${query.state}`,
    method: 'get'
  })
}

export function state(id, state) {
  return request({
    url: `annex/state/${id}/${state}`,
    method: 'get'
  })
}

export function count() {
  return request({
    url: 'annex/count',
    method: 'get'
  })
}

export function packageAnnex(id) {
  return request({
    url: `annex/package/${id}`,
    method: 'get'
  })
}

export function checkPackage(id) {
  return request({
    url: `annex/checkPackage/${id}`,
    method: 'get'
  })
}
